import React from 'react'

import { SvgProps } from './types'

function CompareSvg({
  width,
  height,
  className,
  size,
  styles,
  stroke,
  strokeColor,
}: SvgProps) {
  const { innerWidth } = window
  const defaultWidth = innerWidth > 1024 ? 's' : 'm'
  const sizeKey = typeof size === 'undefined' ? defaultWidth : size

  const scale = {
    xl: 3.0,
    lg: 2.5,
    m: 1.0,
    s: 0.8,
    xs: 0.5,
  }

  return (
    <svg
      className={className}
      style={{
        ...styles,
        ...{
          transform: `scale(${scale[sizeKey]})`,
        },
      }}
      width={width || '48'}
      height={height || '48'}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 .5 19 19"
      strokeWidth={stroke || 1.5}
      fill="none"
      stroke={strokeColor}
    >
      <path
        d="M10 18.333L10 1.66634"
        stroke={strokeColor}
        strokeWidth={stroke}
        strokeLinecap="round"
      />
      <path
        d="M10.0002 2.95182H4.7002C3.7337 2.95182 2.9502 3.73532 2.9502 4.70182L2.9502 15.2969C2.9502 16.2634 3.7337 17.0469 4.7002 17.0469H10.0002"
        stroke={strokeColor}
        strokeWidth={stroke}
        strokeLinecap="round"
      />
      <path
        d="M9.3584 2.95182H15.2999C16.2664 2.95182 17.0499 3.73532 17.0499 4.70182V15.2969C17.0499 16.2634 16.2664 17.0469 15.2999 17.0469H9.35822"
        stroke={strokeColor}
        strokeWidth={stroke}
        strokeLinecap="round"
        strokeDasharray="3 3.5"
      />
    </svg>
  )
}

export default CompareSvg
